$(document).ready(function() {
  var mf = "";
  
  function changed_language(lang){
    var html = '';
    if ( lang == 'en') {
      html += '<p class="clear_msg">Wishlist is empty </p>';
    } else if(lang == 'fr'){
      html += '<p class="clear_msg">La liste de favoris est vide </p>';
    }
    return html;
  }

  
  if(!window.SwymCallbacks){window.SwymCallbacks = [];}
  window.SwymCallbacks.push(function(){
    _swat.fetchWrtEventTypeET(function(products){
      var html = [];
      if(products.length > 0){
        for(var i=0; i<products.length; i++){
          if(typeof products[i].vi !== undefined ){
            var all_variant = products[i].vi;
            if (all_variant.indexOf("/") > -1) {
              var size = all_variant.split("/");
            }
          }          
          var handle = products[i].du;
          var handle1 = handle.split("/");
          var v_id = products[i].epi;                                             
          var handle_1 = handle1[4];                     

          html += '<form method="post" action="/cart/add" class="card" data-product="'+products[i]+'">'
          html += '<span class="rmv" aria-label="Delete" data-id="'+products[i].epi +'">X</span>';
          html += '<div class="tt"><div class="p_image"><a href='+products[i].du+'?variant='+products[i].epi+'><img src='+products[i].iu+' alt="product"></a></div>';
          html += '<div class="description">';
          //           html += '<span>'+products[i].dt+'</span>';
          html += '<span class="p_name"><span class="p_name1" data-id='+ products[i].epi +' data-du='+products[i].du+' data-empi='+products[i].empi+' data-lid='+products[i].lid+'><a href='+products[i].du+'?variant='+products[i].epi+'>Name : </span>'+ products[i].dt +'</span></a>';
          if(typeof size !== undefined ){
            html += '<span class="p_size"><span class="p_size1">Size : </span>'+size[1] +'</span>';
          }
          html += '<span class="p_price"><span class="p_price1">Price : </span><span class="price">'+ Shopify.formatMoney(products[i].pr * 100, mf)  +'</span></span>';
          html += '</div>'; 
          html += '<div class="wishlist_addtocart">';
          html += '<input value='+products[i].epi+' name="id" type="hidden"/><input value="1" name="quantity" type="hidden"/><input class="button btn addtocart spo-container '+ v_id +'"  data-lable="Add To Cart" type="submit" value="Add to cart" name="add"/>'
          html += '</div>';
          html += '</div>';
          html += '</form>'
          $(".swym-delete").attr("data-lid",products[i].lid);
        }
      }
      else{
        html+= changed_language(Weglot.getCurrentLang());
        $(".swym-wishlist-detail-header").css("display","none");
      }
      $(".wish_list").append(html);
    }, _swat.EventTypes.addToWishlist);
  });

  Weglot.on("languageChanged", function(newLang, prevLang) {
    var html = changed_language(newLang);
    $(".wish_list").html(html);
  })
  
  
  
  
  
  
  

  /* add to cart */
  $('body').on('click', '.addtocart',function(event){
    var form = $(this).closest('form').attr('data-product');
    _swat.replayAddToCart(form, form.epi, function() {
      // Successfully added, open cart]
      _swat.openCartPage();
    });
  });


  /* remove from page */
  var count = 0;
  $('body').on('click', '.rmv',function(){
    if($('.rmv').length == 1){
      count = 1;
    }
    var form1 = $(this).attr('data-id');
    $(this).closest("form").remove();
    window._swat.removeFromWishList(
      {
        "epi": form1,
      },
      function(r) {
        if(count == 1){
          $(".wish_list").html('<p class="clear_msg">Wishlist is cleared </p>');
          $(".swym-wishlist-detail-header").css("display","none");
        }
      }
    );
  });

  /* share wishlist */
  $('body').on('click', '.share',function(e){
    e.preventDefault();
    var noteTxt = $(".Share_note").val();
    var emailId = $(".Share_Email").val();
    var fromEmailId = $(".customer_email").attr("data-customer"); 
    _swat.sendEmailWishList(function callback() {
      // Successfully sent
      //       $(".share_main").css("display","none");
      //       $(".share_message").css("display","block");
      $(".share_main").html('<button class="swym-close-btn" aria-label="Close Modal">X</button><div class="share_message"><span>wishlist has been shared</span></div>');
    }, emailId,fromEmailId, noteTxt);
  });

  /* save wishlist */
  function successCallback(){ 
    $(".swym-success-icon").css("display","block");
    $("#fname").val('');
    $("#lname").val('');
    $("#email").val('');
  }
  function errorCallback(){ }
  $('body').on('click', '.Save',function(e){   
    $(this).text("SAVED");
    var params = {
      fname: $("#fname").val(),
      lname: $("#lname").val(),
      email:$("#email").val()
    };
    _swat.saveShopperContext($("#email").val(), params, successCallback, errorCallback);
    
    var k_id = $(this).closest(".save_main").find(".klaviyo_id").attr("data-klaviyo-id");
      if(k_id != ""){
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        "method": "POST",
        "headers": {
          "content-type": "application/x-www-form-urlencoded",
          "cache-control": "no-cache"
        },
        "data": {
          "g": k_id,
          "$fields": "$first_name,$last_name,$source",
          "email": $("#email").val(),
          "$first_name":$("#fname").val(),
          "$last_name": $("#lname").val(),
          "$source": "Custom Form"
        }
      }
      $.ajax(settings).done(function (response) {
        console.log(response);
      });
      }

  });


  /* clear wishlist*/
  $('body').on('click', '.swym-delete',function(e){
    var lid = $(this).attr('data-lid');
    var data1 = [];
    $('.card').each(function(index, value) {
      var item = {};
      var form_obj = $(this).find(".p_name1");
      var epi = form_obj.attr("data-id"),
          du = form_obj.attr("data-du"),
          empi = form_obj.attr("data-empi");
      item.du = du;
      item.epi = epi;
      item.empi = empi;
      data1.push(item);
    });
    _swat.removeProductsFromList(lid, data1, function(resp){
      $(".wish_list").empty();
      $(".wish_list").html('<p class="clear_msg">Wishlist is cleared </p>');
      $(".swym-wishlist-detail-header").css("display","none");
    }, function(xhrObject) {
    });
  });

  
  

  /* savelist and login form */
  $('body').on('click', '.Guest_Shopper',function(e){
    $(".Guest_form").css("display","flex");
    $(".overlay-wishlist").css("display","block");
    $("body").addClass("no-scroll");

  });

  $('body').on('click', '.close_model,.cancle_form,.overlay-wishlist',function(){
    $(".Guest_Shopper_form").css("display","none");
    $(".overlay-wishlist").css("display","none");
    $("body").removeClass("no-scroll");
  });

  /* customer popup*/
  $('body').on('click', '.customer_btn',function(){
    $(".customer_form").css("display","flex");
    $(".overlay-wishlist").css("display","block");
    $("body").addClass("no-scroll");
  });

  /* save share popup*/
  $('body').on('click', '.save_list',function(){
    $(".save_details").css("display","flex");
    $(".overlay-wishlist").css("display","block");
    $(".Guest_form").css("display","none");
    $("body").addClass("no-scroll");
  });

  $('body').on('click','.swym-close-btn,.overlay-wishlist',function(){
    if($(".save_details").length){
      $(".save_details").css("display","none");
    }
    if($(".share_details").length > 0){
      $(".share_details").css("display","none");
    }
    $(".overlay-wishlist").css("display","none");
    $("body").removeClass("no-scroll");
  });

  $('body').on('click', '.swym-share',function(){
    $(".share_details").css("display","flex");
    $(".overlay-wishlist").css("display","block");
    $("body").addClass("no-scroll");
  });
  

});

